// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App.vue';
import Vue from 'vue';
import { attemptReboot } from './support';
import bus from './services/bus';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// attempt reboot every 4 hours
setInterval(() => attemptReboot(4), 1000 * 60);

// attempt reboot when error occurs
window.onerror = () => bus.$emit('reboot');

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

store.dispatch('initialize');
